import { filterProps } from '@roc/ui/utils';
import { GridColumnProps } from '@roc/ui';

export const DEFAULT_SORT_MODEL = [{ colId: 'businessTimeAssigned', sort: 'desc' }];

export const tamariskDashboardColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    cellRenderer: 'loanIdCellRenderer',
    width: 110,
    ...filterProps(),
  },
  {
    field: 'loanType',
    headerName: 'Loan Type',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'submissionDate',
    headerName: 'Submission Date',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'loanStatus',
    headerName: 'Loan Status',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'Lender',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'assignee',
    headerName: 'Assignee',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'tamariskSpecialist',
    headerName: 'Tamarisk Specialist',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'dueDate',
    headerName: 'Due Date',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'taskAssignedDate',
    headerName: 'Task Assigned Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'businessTimeAssigned',
    headerName: 'Business Time Assigned',
    minWidth: 220,
    ...filterProps(),
  },
];
